// Sollte eigentlich alles in zwei Module aufgeteilt werden, 1x HTML und 1x JS.
import { Modules } from "./Modules";

export var modules: Modules = new Modules();
var timer = performance.now();
var boolo = false;
declare var window: any;
modules.preInit();
document.addEventListener("DOMContentLoaded", async function() {
    try {
        await boolVal();
        console.log( performance.now());
    }
    catch(err) { console.log(err); }
});

const boolVal = async ()=> {
    boolo = await modules.checkRequirements();
    if ( boolo ) await modules.init();
}





// import { Modules } from "./Modules";
// declare var window: any;

// export var modules: Modules = new Modules();
// var boolo = false; // global var, don't delete.
// window.ezmodules = modules;
// console.log('%c Script finished: ' + performance.now(), 'background: #000; color: red');


/**
 * What needs to be inside of the ressources.html file to make it work!
 * gzip -c conf.yaml > conf.yaml.gz
 * <script async src="/resources/modules/dynamic-bundle-prod/main.556e54f23069cf4311c3.bundle.js"></script>
<script>
	console.log('%c HTML script start: ' + performance.now(), 'background: #000; color: orange');
	var compressedData; // Variable to store compressed data
	var staticVersionControl = '1.0';

	async function main() {
		try {
			const url = "/resources/modules/conf.yaml.gz";
			compressedData = await getFileFromCache('ConfYamlGZ');
			// If Found
			if( compressedData ) {
				console.log(' File found in cache.');
				console.log('%c HTML script finished: ' + performance.now(), 'background: #000; color: orange');
				console.log(document.readyState);
				startLoadingModules();
				return;
			}
			// Not found, try to laod and then give response
			if (!compressedData) {
				console.log("File not found in cache, fetching from URL...");
				compressedData = await fetchFileAndUpdateCache(url);
			}
			if (compressedData) {
				console.log("File fetched and cached successfully:", compressedData);
				console.log('%c HTML script finished: ' + performance.now(), 'background: #000; color: orange');
				console.log(document.readyState);
				startLoadingModules();
			} else {
				console.error('Failed to fetch or cache data');
			}
		} catch (error) {
			console.error('Error in main function:', error);
		}
	}
	// Check existenz
	function getFileFromCache(url) {
		const cachedData = localStorage.getItem(url);
		if (cachedData) {
			const { data, currentversion } = JSON.parse(cachedData);
			// const staticVersionControl = '1.1';
			// If current version
			if (currentversion  === staticVersionControl) {
				return Promise.resolve(data);
			}
			// If older version
			else {
				// Remove expired cache
				localStorage.removeItem(url);
				return Promise.resolve(null);
			}
		} else {
			return Promise.resolve(null);
		}
	}
	// Create new Cache data
	function cacheFile(data) {
		// const currentVersion = '1.1';
		const cacheObject = { data: Array.from(data), currentversion:staticVersionControl };
		localStorage.setItem('ConfYamlGZ', JSON.stringify(cacheObject));
	}

	// Fetch transformed data
	async function fetchFileAndUpdateCache(url) {
		try {
			const data = await fetchData(url);
			if (data) {
				cacheFile( data);
			}
			return data;
		} catch (error) {
			console.error('Error fetching and caching file:', error);
			return null;
		}
	}
	// Fetch data & transform in correct format
	async function fetchData(url) {
		try {
			const response = await fetch(url);
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			const buffer = await response.arrayBuffer();
			return new Uint8Array(buffer);
		} catch (error) {
			console.error('Error fetching data:', error);
			return null;
		}
	}

	main();

	function startLoadingModules() {
		if (document.readyState === 'complete' || document.readyState === 'interactive') {
			typeof window.ezmodules !== 'undefined' ? executeModuleSys() : window.addEventListener('load', executeModuleSys, { once: true });
		} else {
			// Document still loading, wait for DOMContentLoaded
			window.addEventListener('DOMContentLoaded', () => {
			typeof window.ezmodules !== 'undefined' ? executeModuleSys() : window.addEventListener('load', executeModuleSys, { once: true });
			}, { once: true });
		}
	}
	async function executeModuleSys() {
		console.log('%c Script execute start: ' + performance.now(), 'background: #000; color: lime');
		boolo = await window.ezmodules.checkRequirements();
		if ( boolo ) {
			await window.ezmodules.init();
			console.log('%c  Script execute finished: ' +performance.now(), 'background: #000; color: lime');
		}
	}
</script>
*/